"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateTick = void 0;
var diveAi_common_sidecar_1 = require("./diveAi_common-sidecar");
var enumsAi_1 = require("./enumsAi");
function updateTick(obj) {
    if (obj.pathResult) {
        // Still moving
        return;
    }
    if (obj.ai.state === enumsAi_1.EAiState.FleeBasic) {
        diveAi_common_sidecar_1.diveAi_common.doFleeBasic(obj);
        return;
    }
    // Find nearest target
    var target = diveAi_common_sidecar_1.diveAi_common.findNearestOrPreferredTarget(obj, {
        type: enumsAi_1.EAiTargetType.Hero,
        range: 7,
        requireVision: true,
        requireAlive: true,
        requireLineOfFire: true,
    });
    // Move off if too many units here
    if (diveAi_common_sidecar_1.diveAi_common.moveOffIfTooManyUnitsHere(obj, target)) {
        return;
    }
    if (target) {
        diveAi_common_sidecar_1.diveAi_common.doSeekTarget_MeleeBasic(obj, target);
    }
    else {
        // Wait
        if (obj.rando.chance(0.95)) {
            return;
        }
        diveAi_common_sidecar_1.diveAi_common.doWanderBasic(obj);
    }
}
exports.updateTick = updateTick;
